interface ClockIconProps {
  width?: number;
  height?: number;
  className?: string;
}

export const ClockIcon = ({
  width = 14,
  height = 14,
  className = '',
}: ClockIconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <circle cx='12' cy='12' r='10' stroke='currentColor' strokeWidth='2' />
      <path
        d='M12 6v6l4 2'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
      />
    </svg>
  );
};
